import { mapTwoWayState } from 'schepotin-vuex-helpers';

export default {
    computed: {
        ...mapTwoWayState({
            namespace: 'topic',
            prefix: true,
        }, [
            'topic',
        ]),
    },
};



// WEBPACK FOOTER //
// ./src/mixins/topic.js